module.exports = __webpack_public_path__ + "img/李月汝.8bcad1f0.jpg";